/**
 * Mock 书籍管理 API
 *
 * 提供 Mock 书籍的管理操作
 */

import httpRequest from '@/utils/api'
import type {
  Book,
  CreateBookRequest,
  UpdateBookRequest,
  BookListResponseData,
} from '@/types/mock/book'

enum API {
  books = '/mock-api/admin/books',
  book = '/mock-api/admin/books/:bookId',
}

/**
 * 获取所有书籍
 *
 * @returns 书籍列表响应
 */
export const getAllBooksAPI = () => {
  return httpRequest.get<BookListResponseData>({
    url: API.books,
  })
}

/**
 * 创建书籍
 *
 * @param data 创建请求数据
 * @returns 书籍详情响应
 */
export const createBookAPI = (data: CreateBookRequest) => {
  return httpRequest.post<Book>({
    url: API.books,
    data,
  })
}

/**
 * 更新书籍
 *
 * @param bookId 书籍 ID
 * @param data 更新请求数据
 * @returns 书籍详情响应
 */
export const updateBookAPI = (bookId: number, data: UpdateBookRequest) => {
  return httpRequest.patch<Book>({
    url: API.book.replace(':bookId', bookId.toString()),
    data,
  })
}

